import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import useChoferes from 'app/chofer/services/ChoferService';

/**
 * Hook personalizado para obtener nombres de choferes
 * y proporcionar una función helper para obtener el nombre de un chofer por ID
 */
export const useDriverNames = () => {
  const driverRepository = useChoferes();

  // Cargar choferes activos
  const driversQuery = useSuperQuery(() =>
    driverRepository.getChoferes('?isDeleted=false')
  );

  /**
   * Obtiene el nombre completo de un chofer basado en su ID
   * @param driverId - ID del chofer
   * @returns Nombre del chofer con formato "#codigo - nombreCompleto" o el ID como string si no se encuentra
   */
  const getDriverName = (driverId: number): string => {
    const driver = (driversQuery.data ?? []).find((x) => x.id === driverId);
    return driver ? `#${driver.codigo} - ${driver.nombreCompleto}` : driverId.toString();
  };

  /**
   * Obtiene el objeto completo del chofer basado en su ID
   * @param driverId - ID del chofer
   * @returns Objeto del chofer o undefined si no se encuentra
   */
  const getDriver = (driverId: number) => {
    return (driversQuery.data ?? []).find((x) => x.id === driverId);
  };

  return {
    driversQuery,
    getDriverName,
    getDriver,
    isLoading: driversQuery.isLoading
  };
};

